import { campusEnums } from '../../enums'

const getNodesById = (state) => state.quiz.nodesById

const getCurrentNode = (state) => state.quiz.currentNode

const getPreviousNode = (state) => state.quiz.previousNode

const getCurrentSession = (state) => state.quiz.currentSession

const getInitialNode = (state) => state.quiz.initialNode

const getSelectedCampus = (state) => {
  const { currentNode } = state.quiz
  if (/online/ig.test(currentNode)) {
    return campusEnums.codes.ONLINE
  }
  if (/ground/ig.test(currentNode)) {
    return campusEnums.codes.CLEARWATER
  }
  return campusEnums.codes.UNKNOWN
}

const getSelectedProgram = (state) => {
  if (state.quiz.previousSession) {
    return state.quiz.previousSession.answer || 'UNSPEC'
  }
  return 'UNSPEC'
}

export {
  getCurrentNode,
  getNodesById,
  getPreviousNode,
  getCurrentSession,
  getSelectedCampus,
  getSelectedProgram,
  getInitialNode,
}
